import { combineReducers } from '@reduxjs/toolkit';
import createSystemUiModuleComponentReducer from './create-system-ui-module-component';
import deleteSystemUiModuleComponentReducer from './delete-system-ui-module-component';
import updateSystemUiModuleComponentReducer from './update-system-ui-module-component';

const systemUiModuleComponentReducer = combineReducers({
  createSystemUiModuleComponent: createSystemUiModuleComponentReducer,
  deleteSystemUiModuleComponent: deleteSystemUiModuleComponentReducer,
  updateSystemUiModuleComponent: updateSystemUiModuleComponentReducer
});

export default systemUiModuleComponentReducer;